import {
  alertMessagesArgsConfig,
  collectionArgsConfig,
  collectionFieldArgsConfig,
  getItemIdFromArgsConfig,
} from '../../utils/event_constants';

export const signaturePadActions = [
  {
    name: 'saveSignature',
    label: 'Save Signature',
    args: [
      {
        name: 'source',
        label: 'Source',
        type: 'dropdown',
        optionsType: 'sourceApi',
        options: [],
        value: 'PAGE',
      },
      {
        name: 'page',
        label: 'Page',
        type: 'dropdown',
        options: [],
        optionsType: 'hideComponentPageApi',
        value: '',
      },
      {
        name: 'pageSignPadComponent',
        label: 'Page Components',
        type: 'dropdown',
        optionsType: 'pageSignPadComponentApi',
        options: [],
        value: '',
      },
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'collectionField' }),
      ...getItemIdFromArgsConfig,
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'clearSignature',
    label: 'Clear Signature',
    args: [
      {
        name: 'source',
        label: 'Source',
        type: 'dropdown',
        optionsType: 'sourceApi',
        options: [],
        value: 'PAGE',
      },
      {
        name: 'page',
        label: 'Page',
        type: 'dropdown',
        options: [],
        optionsType: 'hideComponentPageApi',
        value: '',
      },
      {
        name: 'pageSignPadComponent',
        label: 'Page Components',
        type: 'dropdown',
        optionsType: 'pageSignPadComponentApi',
        options: [],
        value: '',
      },
    ],
  },
];
